export const PHOTO_BACKDROPS = {
  mountains: { primary: "/images/bg-mountains.jpg", fallback: "/images/reunion-bg.jpg" },
  turtle: { primary: "/images/bg-turtle.jpg", fallback: "/images/hero-bg.jpg" },
  sunset: { primary: "/images/bg-sunset.jpg", fallback: "/images/hero-bg.jpg" },
  sea: { primary: "/images/bg-sea.jpg", fallback: "/images/hero-bg.jpg" },
  seaWave: { primary: "/images/bg-sea-wave.jpg", fallback: "/images/hero-bg.jpg" }, // Fallback plus léger au lieu de bg-wave.jpg (10.5MB)
  wave: { primary: "/images/bg-wave.jpg", fallback: "/images/hero-bg.jpg" },
  volcanoRoad: { primary: "/images/bg-volcano-road.jpg", fallback: "/images/reunion-bg.jpg" },
  plain: { primary: "/images/bg-plain.jpg", fallback: "/images/reunion-bg.jpg" },
  waterfall: { primary: "/images/bg-waterfall.jpg", fallback: "/images/hero-bg.jpg" },
};

/**
 * Retourne un style inline pour `pr-backdrop--photo`.
 * - Accepte soit une string (url), soit un objet {primary,fallback}.
 * - Utilise un fallback CSS: `background-image: url(primary), url(fallback)`
 */
export const backdropStyle = (photo) => {
  if (!photo) return undefined;

  if (typeof photo === "string") {
    return { "--pr-backdrop-image": `url("${photo}")` };
  }

  const primary = photo.primary;
  const fallback = photo.fallback;
  if (!primary && !fallback) return undefined;
  if (primary && fallback) {
    return { "--pr-backdrop-image": `url("${primary}"), url("${fallback}")` };
  }
  return { "--pr-backdrop-image": `url("${primary || fallback}")` };
};


